import React, { useState } from 'react';

import 'rsuite/dist/rsuite-no-reset.min.css';
import '../styles/global.scss';
import fontawesome from '@fortawesome/fontawesome';
import { faCheckSquare, faCoffee, faTrash } from '@fortawesome/fontawesome-free-solid';
import NavbarCustom from '../components/NavbarCustom';
import IndexPage from './index';
import AboutPage from './about';
import FaqPage from './faq';
import ContactPage from './contact';
import NotificationsPage from './notifications';
import DataEntryPage from './data-entry';
import DashboardPage from './dashboard';
import ChartPage from './chart';
import SQCPrintPage from './sqcprint';
import AuthPage from './auth';
import PersonnelPage from './personnel';
import SettingsPage from './settings';
import LegalPage from './legal';
import { Redirect, Route, Router, Switch } from '../util/router';

import { currentLogo, currentLogoAncillary } from '../util/firebase';
import FirebaseActionPage from './firebase-action';
import NotFoundPage from './404';
import Footer from '../components/Footer';
import { AuthProvider } from '../util/auth';
import { QueryClientProvider } from '../util/db';
import PrintCalculationPage from './print-calculation';
import PrintReportPage from '../components/ReportsSection/PrintReportPage';
import AppContext from '../components/AppContext';
import PrintInitialAssessmentPage from '../components/AssessmentsSection/PrintInitialAssessmentPage';
import PrintPeriodicAssessmentPage from '../components/AssessmentsSection/PrintPeriodicAssessmentPage';
import FuelRedirect from '../components/FuelRedirect';

fontawesome.library.add(faCheckSquare, faCoffee, faTrash);

function App() {
  const pathsWithoutLayout = ['/print-calculation'];

  const [currentFullKey, setCurrentFullKey] = useState(null);

  return (
    <QueryClientProvider>
      <AuthProvider>
        <AppContext.Provider value={{ currentFullKey, setCurrentFullKey }}>
          <Router>
            <>
              {!pathsWithoutLayout.includes(location) && (
                <NavbarCustom
                  bg="white"
                  variant="light"
                  expand="md"
                  logo={currentLogo}
                  logoAncillary={currentLogoAncillary}
                />
              )}
              <Switch>
                <Route exact path="/" component={IndexPage} />

                {/* Redirect Fuel routes to Fuel app */}
                <Route exact path="/spc-dashboard" component={FuelRedirect} />
                <Route exact path="/spc" component={FuelRedirect} />
                <Route exact path="/spcmd" component={FuelRedirect} />
                <Route exact path="/ilcp" component={FuelRedirect} />
                <Route path="/instrument" component={FuelRedirect} />
                <Route exact path="/product" component={FuelRedirect} />
                <Route exact path="/stdcmp/report" component={FuelRedirect} />
                <Route exact path="/pipeline" component={FuelRedirect} />
                <Route exact path="/1090-w-ARV" component={FuelRedirect} />
                <Route exact path="/samples" component={FuelRedirect} />
                <Route path="/samples/:sampleId" component={FuelRedirect} />

                <Route exact path="/about" component={AboutPage} />

                <Route exact path="/faq" component={FaqPage} />

                <Route exact path="/contact" component={ContactPage} />

                <Route exact path="/dashboard" component={DashboardPage} />

                <Route exact path="/chart" component={ChartPage} />
                <Route exact path="/sqcprint" component={SQCPrintPage} />

                <Route exact path="/data-entry" component={DataEntryPage} />

                <Route exact path="/notifications" component={NotificationsPage} />

                <Route exact path="/master" component={PersonnelPage} />

                <Route exact path="/scheduler" render={() => <Redirect to="/notifications" />} />
                <Route exact path="/personnel" render={() => <Redirect to="/master" />} />

                <Route exact path="/auth/:type" component={AuthPage} />

                <Route exact path="/settings/:section" component={SettingsPage} />

                <Route exact path="/legal/:section" component={LegalPage} />

                <Route exact path="/firebase-action" component={FirebaseActionPage} />
                <Route exact path="/print-calculation" component={PrintCalculationPage} />
                <Route exact path="/print-report" component={PrintReportPage} />
                <Route
                  exact
                  path="/print-initial-assessment"
                  component={PrintInitialAssessmentPage}
                />
                <Route
                  exact
                  path="/print-periodic-assessment"
                  component={PrintPeriodicAssessmentPage}
                />
                <Route component={NotFoundPage} />
              </Switch>
              {!pathsWithoutLayout.includes(location) && (
                <Footer
                  bg="light"
                  textColor="dark"
                  bgImage=""
                  bgImageOpacity={1}
                  copyright="ASTM Insight SQC"
                  logo={currentLogo}
                  logoAncillary={currentLogoAncillary}
                />
              )}
            </>
          </Router>
        </AppContext.Provider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
